<fieldset [attr.id]="question.id">
  <legend>
    <div [attr.aria-labelledby]=" question.id +'-err'"></div>
  </legend>

  @let title = text();
  @if (title) {
    <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
  }

  @if (controlHasError()) {
    <div class="alert  alert-danger error pill form-error-list">
      <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
        <ul>
          @for (err of baseForm.errorMap.get(question.id!); track err) {
            <li>
              <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <!-- make sure aria attributes and other are configurable -->
    <div class="dropdown" hidden="true">
      <input #input type="hidden" [attr.name]="question.id" [attr.id]="question.id" class="form-control {{inputClass}}"
             [required]="question.required || false" [attr.aria-required]="question.required"
             [value]="control.value"
             (keydown.enter)="onEnter($event)"
             readOnly
             [attr.aria-label]="getLabel()"
             [attr.aria-describedby]="getAriaLabels()" [ngClass]="{ 'is-invalid': controlHasError() }"/>
    </div>

  <div class="row">
    <div class="col-12">
      <div class="dropdown" [class.standalone]="standalone" role="radiogroup">
        <div ngbDropdown class="d-inline-block">
          <button class="btn btn-outline-primary form-control form-select"
                  [id]="question.id" ngbDropdownToggle
                  [value]="previousAnswer || null"
                  (focusout)="revalidateInput()"
                  [attr.aria-labelledby]="getAriaLabels()">
            <div class="dropdown-text">{{ optionCode(control.value) || '-- select --' }}</div>
          </button>
          <div ngbDropdownMenu aria-labelledby="getAriaLabels(optionKey)" (blur)="validate()"
               class="dropdown-control-options">
            @if (question.sortAcceptedValues) {
              @for (entry of question.acceptedValues | keyvalue; track $index) {
                <button ngbDropdownItem
                  [attr.aria-label]="entry.key +', '+ ($index+1) + ' of ' + question.acceptedValues!.size"
                  (click)="selectOption(entry.key!);revalidateInput()"
                  (keydown.enter)="onEnter($event)">
                  {{ displayValue(entry.key!, optionCode(entry.key!)) }}
                </button>
              }
            } @else {
              @for (entry of question.orderedAcceptedValues; track $index) {
                <button ngbDropdownItem
                  [attr.aria-label]="entry.key +', '+ ($index+1) + ' of ' + question.orderedAcceptedValues!.length"
                  (click)="selectOption(entry.key!);revalidateInput()"
                  (keydown.enter)="onEnter($event)">
                  {{ displayValue(entry.key!, optionCode(entry.key!)) }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>
    @if (standalone) {
      <div class="col text-end">
        <button class="btn primary rounded-pill confirm-button"
                [attr.aria-label]="getLabel() + '.confirm_button'"
                (click)="onEnter($event)"
                (keydown.enter)="onEnter($event)"> {{ messages.getText('WILL.button.save-and-continue') }}
        </button>
      </div>
    }
  </div>

  @if (control.touched || control.value) {
    <div #feedback class="feedback-icon form-group radio dropdown-feedback-icon" aria-hidden="true">
      <i class="fa" aria-hidden="true"
         [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle': controlHasError() }"></i>
    </div>
  }

</fieldset>

<ng-content></ng-content>
